import { Component , OnInit } from '@angular/core';

@Component({
    selector: 'network-extension-embed',
    template: require('./network-extension-embed.html')
})

export default class NetworkExtensionEmbed implements OnInit {

    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/network-extension/network-extension-embed.ts